import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Chevron from '../assets/images/chevron.svg';
import FeatImage from '../assets/images/feat-image.svg';
import SAC from '../assets/images/sac.png';
import SAC_FF from '../assets/images/sac_firefox.png';
import SANT from '../assets/images/sant.png';
import { getBrowser } from '../modules/Helper';
import $ from 'jquery';
import { lang } from '../lang';
class Home extends Component {
  constructor(props) {
    var devLan = lang.getInterfaceLanguage();
    var language = devLan.split('-');
    lang.setLanguage(language[0]);
    super(props);

    this.noDisp = {};

    this.browser = getBrowser().name;

    const params = new URLSearchParams(props.location.search);
    this.appID = params.get('aid');

    this.appName = 'Search Administrator for Chrome';

    if (this.appID === '56') {
      this.appName = 'Search Administrator Tab';
    } else if (this.appID === '67') {
      this.appName = 'Search Administrator';
    }

    this.btnName = 'CHROME';
    this.btnURL = 'href={process.env.REACT_APP_DOWNLOAD_URL}';
    this.btnURL = process.env.REACT_APP_DOWNLOAD_URL;
    this.image = SAC;

    if (this.browser === 'firefox') {
      this.appName = 'Search Administrator for Firefox';
      this.btnName = 'FIREFOX';
      this.btnURL = process.env.REACT_APP_DOWNLOAD_URL_FIREFOX;
      this.image = SAC_FF;
      this.noDisp = {
        display: 'none',
      };
    }
  }

  componentDidMount() {
    if (this.browser !== 'firefox') {
      $('.home-down').on('click', function() {
        $('html, body').animate(
          {
            scrollTop: $('#cta').offset().top,
          },
          500
        );
      });
    } else {
      $('.home-down').on('click', function() {
        $('html, body').animate(
          {
            scrollTop: $('#cta_ff').offset().top,
          },
          500
        );
      });
    }
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>{lang.home_title}</title>
          <meta name="description" content={`${lang.home_desc}`} />
        </Helmet>

        {/*home splash*/}
        <div className="main-splash -home">
          <div className="head">{lang.splash_main}</div>
          <h1 className="subhead">{lang.splash_main_sub}</h1>
          <a href={this.btnURL} target="_blank" className="primary-btn -centered">
            {lang.addto} {this.btnName}
          </a>
          <a className="home-down">
            <img className="img" src={Chevron} alt="chevron down" />
          </a>
        </div>

        {/*end home splash*/}

        {/*image banner*/}
        <section id="cta" className="main-splash -desc" style={this.noDisp}>
          <div className="head">{lang.customize}</div>
          <p className="subhead">{lang.customize_sub}</p>
        </section>

        {/*end image banner*/}
        {/*feature banner*/}

        <div id="cta_ff" className="main-splash -feat">
          <img className="image" src={FeatImage} alt="Feature" />
          <div className="head">{lang.splash_feat}</div>
          <div className="subhead">{lang.splash_feat_sub}</div>
        </div>

        {/*end feature banner*/}
        {/*product section*/}

        <div className="page-header">{lang.products}</div>
        <div className="product-container">
          <div className="content">
            <div className="product-header">{this.appName}</div>
            <div className="product-content">{lang.sa_default}</div>
            <a href={this.btnURL} target="_blank" className="primary-btn">
              {lang.addto} {this.btnName}
            </a>
          </div>
          <div className="content">
            <img className="image" src={this.image} alt="SA Chrome" />
          </div>
          <div className="content" style={this.noDisp}>
            <img className="image" src={SANT} alt="SA New Tab" />
          </div>
          <div className="content" style={this.noDisp}>
            <div className="product-header">Search Administrator Tab</div>
            <div className="product-content">{lang.sa_tab}</div>
          </div>
        </div>

        {/*end product section*/}
        {/*page-cta*/}

        <div className="main-splash -cta">
          <div className="head">{lang.splash_cta}</div>
          <div className="subhead">{lang.splash_cta_sub}</div>
          <a href={this.btnURL} target="_blank" className="primary-btn -default -centered">
            {lang.addto} {this.btnName}
          </a>
        </div>

        {/*end page-cta*/}
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js